import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto mb-4 mt-6 w-full max-w-[340px]" }
const _hoisted_2 = { class: "text-xs leading-4.5 text-gray-70" }
const _hoisted_3 = { class: "text-xs leading-4.5 text-gray-70" }

import { contextPath } from "@ocm/services/ocm-object";
import { $t } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFootnote',
  setup(__props) {

const auszeichnungenLink = `${window.location.origin}${contextPath}/auszeichnungen/`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref($t)("foot_note.recommended_retail_price")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_unref($t)("foot_note.biggest_outlet_explanation")) + " ", 1),
      _createElementVNode("a", {
        href: auszeichnungenLink,
        class: "break-words underline",
        target: "_blank",
        rel: "noopener"
      }, _toDisplayString(_unref($t)("foot_note.more_information")), 1)
    ])
  ]))
}
}

})